import { render } from "./PaymentIframe.vue?vue&type=template&id=20ab61ac"
import script from "./PaymentIframe.vue?vue&type=script&lang=js"
export * from "./PaymentIframe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__